import type { NextPage, GetStaticProps, GetStaticPropsContext } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import { usePageTitle } from '~/utils/tags'
import WindSurferPage from '~/games/pages/WindSurfer.page'
import ROUTES from '~/shared/constants/routes.const'
import Metatags from '~/components/Metadata/Metatags'
import AuthGuard from '~/components/AuthGuard'
import { COMMON_TRANSLATION_MODULE_NAMES, DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'

const WindSurferGamePage: NextPage = () => {
  const { t } = useTranslation('games')
  const pageTitle = usePageTitle(t('windSurfer.gameTitle'))

  return (
    <>
      <Metatags metaDescription={t('windSurfer.metaDescription')} noindex title={pageTitle} />
      <AuthGuard redirect={ROUTES.WINDSURFER_LOGIN} redirectQuery={{ from: 'windsurfer' }}>
        <WindSurferPage />
      </AuthGuard>
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext) => ({
  props: {
    ...(await serverSideTranslations(locale as string, [
      ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
      ...COMMON_TRANSLATION_MODULE_NAMES,
      'games',
    ])),
  },
})

export default WindSurferGamePage
